import { inject, Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { ExceptionService } from '../services/exception.service';
import { UserFriendlyException } from '../models/auth.models';

@Injectable()
export class UserFriendlyExceptionInterceptor implements HttpInterceptor {

    private _exceptionService: ExceptionService = inject(ExceptionService);

    private _extractFirstValidationError(errors: Record<string, string[]>): string | null {
        for (const key of Object.keys(errors)) {
            const messages = errors[key];
            if (!Array.isArray(messages)) continue;
            for (const msg of messages) {
                const trimmed = typeof msg === 'string' ? msg.trim() : '';
                if (trimmed.length > 0) return trimmed;
            }
        }
        return null;
    }

    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse): Observable<never> => {
                if (error.status === 499 && error.error) {
                    const userFriendlyException: UserFriendlyException = {
                        message: error.error.message || 'An error occurred',
                        type: error.error.type || 'UserFriendlyException'
                    };
                    this._exceptionService.emitUserFriendlyException(userFriendlyException);
                } else if (error.error?.errors && (error.status === 400 || error.status === 422)) {
                    const firstMessage = this._extractFirstValidationError(error.error.errors);
                    if (firstMessage) {
                        this._exceptionService.emitUserFriendlyException({
                            message: firstMessage,
                            type: 'ValidationError'
                        } as UserFriendlyException);
                    }
                } else if (error.status === 403 && error.error?.message) {
                    const message = (error.error.message as string).replace(
                        /([a-z0-9_]+(?:\.[a-z0-9_]+)+)/gi,
                        '[$1]'
                    );
                    this._exceptionService.emitUserFriendlyException({
                        message,
                        type: error.error.code || 'Forbidden'
                    } as UserFriendlyException);
                }

                return throwError((): HttpErrorResponse => error);
            })
        );
    }
} 